// src/locales/ta/paymentVerification.js
import { paymentVerification as paymentVerificationEn } from '../en/paymentVerification';

export const paymentVerification = {
  ...paymentVerificationEn,
  pageTitle: "கட்டணச் சரிபார்ப்பு",
  pageDescription: "ஊழியர்கள் சமர்ப்பித்த கட்டணப் பதிவுகளை மதிப்பாய்வு செய்து சரிபார்க்கவும்",
  orderNumber: "ஆர்டர் எண்",
  paymentMethod: "கட்டண முறை",
  paymentType: "கட்டண வகை",
  amount: "தொகை",
  reference: "கட்டணக் குறிப்பு",
  paymentDate: "கட்டணத் தேதி",
  proof: "கோப்பு",
  isVerified: "சரிபார்க்கப்பட்டதா",
  action: "செயல்",
  createdBy: "உருவாக்கியவர்",
  createdDate: "உருவாக்கப்பட்ட தேதி",
  verifiedBy: "சரிபார்த்தவர்",
  verifiedDate: "சரிபார்த்த தேதி",
  voidedBy: "ரத்து செய்தவர்",
  voidedDate: "ரத்து செய்த தேதி",
  verified: "சரிபார்க்கப்பட்டது",
  unverified: "சரிபார்க்கப்படவில்லை",
  issues: "சிக்கல்கள்",
  void: "ரத்து",
  allPaymentMethods: "அனைத்து கட்டண முறைகள்",
  allPaymentTypes: "அனைத்து கட்டண வகைகள்",
  allStatuses: "அனைத்தும்",
  verifiedOnly: "சரிபார்க்கப்பட்டவை",
  unverifiedOnly: "சரிபார்க்கப்படாதவை",
  searchPlaceholder: "ஆர்டர் எண் அல்லது குறிப்பு மூலம் தேடவும்...",
  noFileChosen: "கோப்பு தேர்ந்தெடுக்கப்படவில்லை",
  viewProof: "பார்க்கவும்",
  viewProofPdf: "பதிவேற்றிய PDF ஐப் பார்க்கவும்",
  changeProof: "மாற்று",
  deleteProof: "நீக்கு",
  confirmDeleteProof: "இந்தப் பதிவுக்கான பதிவேற்றிய கட்டணச் சான்றை நீக்கவா?",
  verify: "சரிபார்",
  save: "சேமி",
  verifySelected: "தேர்ந்தெடுத்தவற்றைச் சரிபார் ({count})",
  clearSelection: "தேர்வை அழி",
  confirmVerify: "இந்தக் கட்டணப் பதிவைச் சரிபார்க்கப்பட்டதாகக் குறிக்கவா?",
  confirmBulkVerify: "தேர்ந்தெடுத்த {count} கட்டணப் பதிவுகளைச் சரிபார்க்கவா? இதைத் திரும்பப் பெற முடியாது.",
  confirmVoid: "ரத்து செய்வது இந்தக் கட்டணப் பதிவைச் செல்லாததாக்கும். இது ஆர்டரின் செலுத்திய தொகையை மாற்றாது.",
  voidReasonLabel: "ரத்து செய்வதற்கான காரணம்",
  flagAsIssue: "சிக்கலாகக் குறிக்கவும்",
  flagIssueDescription: "அழைப்பு மைய ஊழியர்கள் வாடிக்கையாளரைத் தொடர்பு கொள்ள இந்தக் கட்டணப் பதிவைச் சிக்கலாகக் குறிக்கவும்.",
  flagIssueReasonLabel: "சிக்கலை விவரிக்கவும்",
  resolve: "தீர்",
  resolveDescription: "சிக்கல் தீர்ந்தவுடன் இந்தக் கட்டணப் பதிவை மீண்டும் சரிபார்க்கப்படாத நிலைக்கு மாற்றவும்.",
  resolveNoteLabel: "தீர்வுக் குறிப்பு (விருப்பத்தேர்வு)",
  notes: "குறிப்புகள்",
  addNote: "குறிப்பைச் சேர்",
  notePlaceholder: "இந்தக் கட்டணப் பதிவு பற்றிய குறிப்பைச் சேர்க்கவும்...",
  noNotesYet: "இன்னும் குறிப்புகள் இல்லை",
  verifySuccess: "கட்டணப் பதிவு வெற்றிகரமாகச் சரிபார்க்கப்பட்டது",
  verifyFailed: "கட்டணப் பதிவைச் சரிபார்க்க முடியவில்லை",
  bulkVerifySuccess: "{count} கட்டணப் பதிவுகள் வெற்றிகரமாகச் சரிபார்க்கப்பட்டன",
  bulkVerifyPartial: "{totalSubmitted} பதிவுகளில் {successCount} சரிபார்க்கப்பட்டன; {failureCount} தோல்வியடைந்தன",
  bulkVerifyFailed: "தேர்ந்தெடுத்த கட்டணப் பதிவுகளைச் சரிபார்க்க முடியவில்லை",
  updateSuccess: "கட்டணப் பதிவு வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது",
  updateFailed: "கட்டணப் பதிவைப் புதுப்பிக்க முடியவில்லை",
  proofUploadFailed: "கட்டணச் சான்றைப் பதிவேற்ற முடியவில்லை",
  cannotEditVerified: "சரிபார்க்கப்பட்ட பதிவுகளைத் திருத்த முடியாது",
  noUnverifiedSelected: "குறைந்தது ஒரு சரிபார்க்கப்படாத பதிவைத் தேர்ந்தெடுக்கவும்",
  failedToLoad: "கட்டணப் பதிவுகளை ஏற்ற முடியவில்லை",
  noRecordsFound: "கட்டணப் பதிவுகள் எதுவும் இல்லை",
  noRecordsFoundDescription: "உங்கள் தேடல் அளவுகோல்களுடன் பொருந்தும் கட்டணப் பதிவுகள் இல்லை",
  voidSuccess: "கட்டணப் பதிவு வெற்றிகரமாக ரத்து செய்யப்பட்டது",
  voidFailed: "கட்டணப் பதிவை ரத்து செய்ய முடியவில்லை",
  flagIssueSuccess: "கட்டணப் பதிவு சிக்கலாகக் குறிக்கப்பட்டது",
  flagIssueFailed: "கட்டணப் பதிவைக் குறிக்க முடியவில்லை",
  resolveSuccess: "கட்டணப் பதிவின் சிக்கல் தீர்க்கப்பட்டது",
  resolveFailed: "கட்டணப் பதிவின் சிக்கலைத் தீர்க்க முடியவில்லை",
  noteAddSuccess: "குறிப்பு வெற்றிகரமாகச் சேர்க்கப்பட்டது",
  noteAddFailed: "குறிப்பைச் சேர்க்க முடியவில்லை",
  notesLoadFailed: "குறிப்புகளை ஏற்ற முடியவில்லை",
  referenceRequiredForBankTransfer: "வங்கி பரிமாற்றக் கட்டணத்தைச் சரிபார்க்க கட்டணக் குறிப்பு எண் தேவை",
  saveChangesBeforeVerify: "இந்தக் கட்டணத்தைச் சரிபார்க்கும் முன் உங்கள் மாற்றங்களைச் சேமிக்கவும்",
  bulkUnsavedChanges: "தேர்ந்தெடுத்த {count} கட்டணப் பதிவுகளில் சேமிக்கப்படாத மாற்றங்கள் உள்ளன. சரிபார்க்கும் முன் அவற்றைச் சேமிக்கவும்.",
  bulkReferenceMissing: "தேர்ந்தெடுத்த {count} வங்கி பரிமாற்றக் கட்டணங்களுக்குக் கட்டணக் குறிப்பு எண் இல்லை. சரிபார்க்கும் முன் குறிப்பு எண்களைச் சேர்க்கவும்.",
};
